import { getMemberWatchlistFilms } from './get-member-watchlist-films';
export const getMemberWatchlistFilmIds = () => {
    const films = getMemberWatchlistFilms();
    return films === null || films === void 0 ? void 0 : films.map(film => film.filmId);
};
